module.exports = __webpack_public_path__ + "static/media/unaccompanied-baggage.bfffa888.jpg";